// @flow

/**
 * Display subinfo below prices (taxes) or expirations dates, etc.
 */

import * as React from 'react';

import { Text } from '@gandi/ui';

import styles from './SubInfo.scss';

type Props = {
  children: React.Node,
  inline?: boolean,
};

export default function SubInfo({
  children,
  inline,
}: Props): React.MixedElement {
  const className = inline ? styles.inline : styles.text;
  return (
    <div className={className}>
      <Text weight="regular" size="small" color="grey-darker">
        {children}
      </Text>
    </div>
  );
}
